// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"4de3fe7d","231":"1f8da48d","557":"c0eb0796","698":"df72c046"}[chunkId] + ".chunk.js";
};